<script setup>
import { computed, defineProps } from "vue";

// Definimos las propiedades que FormKit pasa automáticamente
const props = defineProps({
  context: Object, // El contexto contiene todo el estado del nodo
});

// Límite máximo de palabras desde las props o un valor por defecto
const maxWords = Number(props.context.maxWords) || 300;

// Función para actualizar el valor del nodo (v-model)
function handleInput(e) {
  const value = e.target.value;
  props.context.node.input(value); // Actualiza el valor del nodo
}

const wordCount = computed(() => {
  let s = props.context._value
  if (s === undefined) return 0;
  if (s === null) return 0;
  s = s.replace(/(^\s*)|(\s*$)/gi, "");//exclude  start and end white-space
  s = s.replace(/[ ]{2,}/gi, " ");//2 or more space to 1
  s = s.replace(/\n /, "\n"); // exclude newline with a start spacing
  return s.split(' ').filter(function (str) { return str != ""; }).length;
  //return s.split(' ').filter(String).length; - this can also be used
});


const minHeight = computed(() => props.context.attrs.props.minHeight);
const maxWordsRule = computed(() => props.context.attrs.props.maxWordsRule);
// Como es el nombre
const name = computed(() => props.context._name);

// Validación del máximo de palabras
const isExceeded = computed(() => wordCount.value > maxWords);

// Emitir que es inválido si se excede el límite
</script>

<template>
  <div class="formkit-wordcount">
    <textarea :value="context._value" :rows="context.minRows || 5"
      :class="[context.classes.input, { exceeded: isExceeded }]" @input="handleInput" :style="{
        minHeight: minHeight,
      }"></textarea>

    <div class="flex items-center justify-end mt-1 font-medium text-sm">
      <div class="word-counter" :class="{ 'limit-exceeded': isExceeded }">
        {{ wordCount }} / {{ maxWordsRule }} palabras
      </div>

      <!-- <div v-if="isExceeded" class="formkit-message text-red-500">
        El texto no debe superar las {{ maxWords }} palabras.
      </div> -->
    </div>
  </div>
</template>

<style scoped lang="scss">
.formkit-wordcount {
  @apply flex flex-col relative;
}

.formkit-wordcount textarea {
  @apply border border-gray-400 rounded p-2 w-full;
  // Minimum height
}

.minHeight textarea {
  min-height: 20rem;
}

.word-counter {
  font-size: 0.8rem;
}

.limit-exceeded {
  color: red;
  font-weight: bold;
}

textarea.exceeded {
  border-color: red;
}
</style>
